import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { AuthGuard } from './services/auth-guard';

import { LandingPageComponent } from './components/landing-page/landing-page.component';
import { CheckoutComponent } from './components/checkout/checkout.component';
import { ProfileSettingsComponent } from './components/profile-settings/profile-settings.component';
import { AdminLoginComponent } from './components/auth/admin-login/admin-login.component';
import { DashboardComponent } from './components/dashboard/dashboard.component';
import { ProductsComponent } from './components/dashboard/right-panel/products/products.component';
import { ProductsTableComponent } from './components/dashboard/right-panel/products/products-table/products-table.component';
import { CreateProductComponent } from './components/dashboard/right-panel/products/create-product/create-product.component';
import { EditProductComponent } from './components/dashboard/right-panel/products/edit-product/edit-product.component';
import { BasketsComponent } from './components/dashboard/right-panel/baskets/baskets.component';
import { BasketsTableComponent } from './components/dashboard/right-panel/baskets/baskets-table/baskets-table.component';
import { CreateBasketComponent } from './components/dashboard/right-panel/baskets/create-basket/create-basket.component';
import { EditBasketComponent } from './components/dashboard/right-panel/baskets/edit-basket/edit-basket.component';
import { DeliveriesComponent } from './components/dashboard/right-panel/deliveries/deliveries.component';
import { DeliveriesTableComponent } from './components/dashboard/right-panel/deliveries/deliveries-table/deliveries-table.component';
import { OrdersComponent } from './components/dashboard/right-panel/orders/orders.component';
import { OrdersTableComponent } from './components/dashboard/right-panel/orders/orders-table/orders-table.component';
import { UsersComponent } from './components/dashboard/right-panel/users/users.component';
import { UsersTableComponent } from './components/dashboard/right-panel/users/users-table/users-table.component';
import { CreateUserComponent } from './components/dashboard/right-panel/users/create-user/create-user.component';
import { EditUserComponent } from './components/dashboard/right-panel/users/edit-user/edit-user.component';
import { UserOrdersComponent } from './components/dashboard/right-panel/users/user-orders/user-orders.component';
import { CreateOrderComponent } from './components/dashboard/right-panel/users/create-order/create-order.component';
import { EditOrderComponent } from './components/dashboard/right-panel/users/edit-order/edit-order.component';
import { TermsAndConditionsComponent } from './components/terms-and-conditions/terms-and-conditions.component';
import { PrivacyPolicyComponent } from './components/privacy-policy/privacy-policy.component';
import { FaqPageComponent } from './components/faq-page/faq-page.component';


const routes: Routes = [
  { path: '', component: LandingPageComponent },

  { path: 'checkout', component: CheckoutComponent, canActivate: [AuthGuard] },
  { path: 'profile', component: ProfileSettingsComponent, canActivate: [AuthGuard] },

  { path: 'terms-and-conditions', component: TermsAndConditionsComponent },
  { path: 'privacy-policy', component: PrivacyPolicyComponent },
  { path: 'faq', component: FaqPageComponent },

  { path: 'admin/login', component: AdminLoginComponent },
  {
    path: 'admin', component: DashboardComponent, canActivate: [AuthGuard], children: [
      {
        path: 'products', component: ProductsComponent, canActivate: [AuthGuard], children: [
          { path: '', canActivate: [AuthGuard], component: ProductsTableComponent },
          { path: 'add', canActivate: [AuthGuard], component: CreateProductComponent },
          { path: 'edit/:id', canActivate: [AuthGuard], component: EditProductComponent }
        ]
      },
      {
        path: 'baskets', component: BasketsComponent, canActivate: [AuthGuard], children: [
          { path: '', canActivate: [AuthGuard], component: BasketsTableComponent },
          { path: 'add', canActivate: [AuthGuard], component: CreateBasketComponent },
          { path: 'edit/:id', canActivate: [AuthGuard], component: EditBasketComponent }
        ]
      },
      {
        path: 'deliveries', component: DeliveriesComponent, canActivate: [AuthGuard], children: [
          { path: '', canActivate: [AuthGuard], component: DeliveriesTableComponent }
        ]
      },
      {
        path: 'orders', component: OrdersComponent, canActivate: [AuthGuard], children: [
          { path: '', canActivate: [AuthGuard], component: OrdersTableComponent }
        ]
      },
      {
        path: 'users', component: UsersComponent, canActivate: [AuthGuard], children: [
          { path: '', canActivate: [AuthGuard], component: UsersTableComponent },
          { path: 'add', canActivate: [AuthGuard], component: CreateUserComponent },
          { path: 'edit/:id', canActivate: [AuthGuard], component: EditUserComponent },
          { path: 'orders', canActivate: [AuthGuard], component: UserOrdersComponent },
          { path: 'orders/create', canActivate: [AuthGuard], component: CreateOrderComponent },
          { path: 'orders/edit', canActivate: [AuthGuard], component: EditOrderComponent }
        ]
      }
    ]
  }
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
